<template>
<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M3.99999 4.56023C3.85661 4.56023 3.71325 4.50549 3.60394 4.39623L0.164113 0.956369C-0.0547045 0.737551 -0.0547045 0.382776 0.164113 0.164047C0.382843 -0.0546823 0.737548 -0.0546823 0.956383 0.164047L3.99999 3.20782L7.04361 0.164153C7.26243 -0.054576 7.61709 -0.054576 7.83581 0.164153C8.05473 0.382882 8.05473 0.737657 7.83581 0.956475L4.39603 4.39633C4.28667 4.50561 4.14331 4.56023 3.99999 4.56023Z"
      fill="#87939E"/>
</svg>
</template>
